import styled from "@emotion/styled";

/* ─── Top Bar ─── */

export const TopBarRoot = styled.header`
    width: 100%;
    flex-shrink: 0;
    background: #1a1a1c;
    padding-top: env(safe-area-inset-top, 0px);
`;

export const TopBarDesktop = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 36px;
    position: relative;

    @media (max-width: 1023px) {
        display: none;
    }
`;

export const TopBarMobile = styled.div`
    display: none;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 16px;

    @media (max-width: 1023px) {
        display: flex;
    }
`;

export const LogoWrap = styled.div`
    flex-shrink: 0;
    padding-right: 20px;
    padding-top: 20px;
    padding-bottom: 20px;

    @media (max-width: 1023px) {
        padding: 8px 0;
    }
`;

export const LogoImg = styled.img<{ $mobile?: boolean }>`
    display: block;
    width: ${(p) => (p.$mobile ? "160px" : "184px")};
    height: auto;
`;

export const TopBarSpacer = styled.div`
    flex: 1;
    min-width: 0;
`;

export const TaglineText = styled.p<{ $mobile?: boolean }>`
  font-family: "Custora", serif;
    font-weight: 400;
    font-size: ${(p) => (p.$mobile ? "14px" : "16px")};
    line-height: 120%;
    color: #b7bdcb;
    white-space: nowrap;
    flex-shrink: 0;
`;

export const TopBarCounter = styled.p`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #e9ecf5;
    white-space: nowrap;
    max-width: 600px;
    width: 600px;
`;

/* ─── Nav Row ─── */

export const NavRowRoot = styled.nav`
    width: 100%;
    max-width: 600px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    position: relative;
    flex-shrink: 0;
    margin: 0 auto;

    @media (max-width: 1023px) {
        max-width: 100%;
        padding: 0 8px;
    }
`;

export const BackBtn = styled.button`
    width: 44px;
    height: 44px;
    border: none;
    background: transparent;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #b7bdcb;

    &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid rgba(233, 236, 245, 0.7);
        outline-offset: 2px;
        border-radius: 8px;
    }
`;

export const ReturnLater = styled.button`
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #b7bdcb;
    opacity: 0.8;
    white-space: nowrap;

    &:hover {
        opacity: 1;
    }
`;

export const NavCounter = styled.span`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    font-family: Inter, system-ui, -apple-system, Segoe UI, sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #e9ecf5;
    white-space: nowrap;

    /* Only visible on mobile — desktop counter is in TopBar */
    display: none;

    @media (max-width: 1023px) {
        display: block;
    }
`;
